import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query';

import { ShortUrl } from '@air/api';
import { type Board } from '@air/api/types';

export const PUBLIC_BOARD_STATS_KEY = 'PUBLIC_BOARD_STATS';

export const getPublicBoardStatsKey = (params: PublicBoardStatsParams) => {
  return [PUBLIC_BOARD_STATS_KEY, params];
};

export type PublicBoardStatsParams = Parameters<typeof ShortUrl.getStatsByShortId>[0]['options'] & {
  shortId: string | undefined;
  boardId: Board['id'] | undefined;
};

export type PublicBoardStatsOptions = {
  enabled?: boolean;
  keepPreviousData?: boolean;
};

export const usePublicBoardStats = (params: PublicBoardStatsParams, options?: PublicBoardStatsOptions) => {
  const shortId = params.shortId;
  const boardId = params.boardId;

  return useQuery({
    queryKey: getPublicBoardStatsKey(params),
    queryFn:
      shortId && boardId ? () => ShortUrl.getStatsByShortId({ id: shortId, boardId, options: params }) : skipToken,
    enabled: !!shortId && !!boardId && options?.enabled,
    placeholderData: options?.keepPreviousData ? keepPreviousData : undefined,
  });
};
